// Languages supported by the backend (see app/models LanguageCode).

export const LANGUAGES = [
    { code: 'eng', name: 'English', native: 'English' },
    { code: 'swa', name: 'Swahili', native: 'Kiswahili' },
    { code: 'kik', name: 'Kikuyu', native: 'Gĩkũyũ' },
    { code: 'kam', name: 'Kamba', native: 'Kikamba' },
    { code: 'mer', name: 'Kimeru', native: 'Kĩmĩrũ' },
    { code: 'luo', name: 'Luo', native: 'Dholuo' },
    { code: 'som', name: 'Somali', native: 'Soomaali' },
];

const byCode = new Map(LANGUAGES.map((l) => [l.code, l]));

const TAGS = { eng: 'en', swa: 'sw', kik: 'ki', kam: 'kam', mer: 'mer', luo: 'luo', som: 'so' };

/** BCP 47 tag for a lang="" attribute. */
export function langTag(code) {
    return TAGS[code] || code || '';
}

export function isSupportedLanguage(code) {
    return byCode.has(code);
}

export function languageName(code) {
    return byCode.get(code)?.name || code || '';
}

/** <option> list for a native <select>. */
export function languageOptions(selected) {
    return LANGUAGES.map((l) =>
        `<option value="${l.code}"${l.code === selected ? ' selected' : ''}>${l.name}</option>`
    ).join('');
}

/** Language code from a participant object, which may arrive camel- or snake-cased. */
export function participantLanguage(p) {
    if (!p) return null;
    const lang = p.language;
    if (typeof lang === 'string') return lang;
    return lang?.code || null;
}
